// Extraído de ChartRenderer.jsx (computePriceFormat) para que otros
// consumidores — indicadores que dibujan sus propios labels de precio fuera
// de una serie de lightweight-charts, como rango_quantum — puedan calcular
// EXACTAMENTE la misma precisión que usa el eje nativo sin importar el
// componente de chart completo. Misma fórmula, mismo resultado: dado el
// mismo array de velas, la precisión calculada aquí y la que aplica
// ChartRenderer.jsx a la serie principal son idénticas.
export function computePriceFormat(candles) {
  const DEFAULT_FORMAT = { type: 'price', precision: 2, minMove: 0.01 }
  if (!candles || candles.length === 0) return DEFAULT_FORMAT
  let minAbs = Infinity
  for (const c of candles) {
    for (const v of [c.open, c.high, c.low, c.close]) {
      if (typeof v === 'number' && Number.isFinite(v) && v !== 0) {
        const av = Math.abs(v)
        if (av < minAbs) minAbs = av
      }
    }
  }
  if (!Number.isFinite(minAbs) || minAbs === 0 || minAbs >= 1) return DEFAULT_FORMAT
  // minAbs < 1: cuántos decimales hacen falta para ~4 cifras significativas.
  const precision = Math.min(10, Math.max(2, Math.ceil(-Math.log10(minAbs)) + 3))
  const minMove = Number((1 / Math.pow(10, precision)).toFixed(precision))
  return { type: 'price', precision, minMove }
}

// Formatea un precio con la precisión REAL del activo (misma fuente que el
// eje nativo, ver computePriceFormat) en vez de una regla de umbrales fija
// por magnitud — evita el desajuste eje/marcador/badge (p.ej. "69610.95" en
// el eje vs "69611.0" en un label con toFixed(1) hardcodeado).
export function formatPriceWithPrecision(v, precision) {
  if (!Number.isFinite(v)) return '—'
  const p = Number.isFinite(precision) ? precision : 2
  return v.toFixed(p)
}
